<!--
    `!invalidURL` nestes dois: eles vivem FORA do `ion-content` e eram os únicos
    do arquivo sem a guarda que o corpo, o rodapé e o `<app-not-found>` já usam.
    Sem restaurante o `BalanceCashbackComponent.ngOnInit` chama
    `cashbackService.getCashbackBalance()`, que desreferencia
    `restaurant.info.id` e estoura (Sentry PEDIRDELIVERY-P). Além do erro, é
    chrome de loja renderizado por cima de uma tela que diz "não encontrado".
-->
<cart *ngIf="!invalidURL"></cart>
<balance-cashback *ngIf="!invalidURL"></balance-cashback>
<ion-content scroll-y="true" [scrollEvents]="true" (ionScroll)="onScroll()" (ionScrollEnd)="onScroll()" [class.menu-content--new-home]="isNewHomePedirDelivery">
    <!-- "Não deu tempo" não é "não existe" — ver menu.page.ts. Sem este bloco,
         quem estava só numa rede ruim lia "loja não encontrada" e ia embora. -->
    <app-not-found *ngIf="invalidURL && !cargaExpirou"></app-not-found>
    <div *ngIf="cargaExpirou" class="carga-expirou">
        <p class="carga-expirou__texto">{{ 'Please reload the page.' | translate }}</p>
        <button type="button" class="carga-expirou__btn" (click)="recarregar()">
            {{ 'Reload' | translate }}
        </button>
    </div>
    <div *ngIf="loaded && !invalidURL" class="menu" [class.menu--blocked]="restaurantIsBlocked">
        <div *ngIf="false" class="insta-ios-banner">
            <ion-grid>
              <ion-row class="insta-ios-row">
                
                <ion-col size="10" class="insta-ios-left">
          
                  <h3 class="insta-ios-title">
                    <ion-icon name="alert-circle-outline"></ion-icon>
                    Você está usando o navegador do Instagram no iOS
                  </h3>
          
                  <p class="insta-ios-subtitle">
                    Sua experiência pode ser limitada. Para melhor uso, siga as instruções abaixo:
                  </p>
          
                  <ol class="insta-ios-steps">
                    <li>
                      Clique no ícone 
                      <b><ion-icon name="ellipsis-horizontal"></ion-icon></b> 
                      no canto superior direito do navegador do Instagram
                    </li>
                    <li>Selecione <b>"Abrir no navegador externo"</b></li>
                  </ol>
          
                </ion-col>
          
                <ion-col size="2" class="insta-ios-right">
                  <ion-icon name="arrow-up-outline" class="insta-ios-corner-icon"></ion-icon>
                </ion-col>
          
              </ion-row>
            </ion-grid>
            <div class="insta-ios-close-container">
              <ion-button fill="clear" size="small" (click)="closeInstagramIosBanner()" class="insta-ios-close-btn">
                Fechar
              </ion-button>
            </div>
          </div>
        <app-header [restaurant]="restaurant"></app-header>

        <div *ngIf="isNewHomePedirDelivery && highlightImages.length > 0" class="featured-carousel" appDragScroll>
          <span *ngFor="let image of highlightImages" style="position: relative">
            <img draggable="false" class="highlight-image" src="{{imgURL}}/highlightImages/{{image.image}}/lg_{{image.image}}.jpg"/>
          </span>
        </div>

        <div *ngIf="restaurantIsBlocked" class="menu__blocked-state container text-center" style="width: 100%;">
            <ion-icon name="alert-circle" style="font-size: 40px; margin-top: 70px; color: #AAA;"></ion-icon>
            <h4 class="mt-0" style="color: #AAA; font-size: 20px; font-weight: 600;" translate>Menu currently unavailable</h4>
        </div>

        <div *ngIf="!restaurantIsBlocked">
            <show-recommended-products 
                *ngIf="recommendedProducts.length > 0"
                [recommendedProducts]="recommendedProducts"
                [restaurant]="restaurant"
            ></show-recommended-products>
         
            <!-- Nova versão: barra sticky + pills/select + input na barra ou abaixo -->
            <ng-container *ngIf="isNewHomePedirDelivery">
                <div #stickyBar class="menu-sticky-bar" [class.menu-sticky-bar--sticky]="isSticky">
                    <img *ngIf="isSticky && restaurantProfilePicUrl" class="menu-sticky-avatar" [src]="restaurantProfilePicUrl" [alt]="restaurant.info.name">
                    <category-nav
                        [categories]="categories"
                        [itemsToHide]="itemsToHide"
                        [comboCategoryName]="restaurant.info.combo_category_name"
                        [pizzaCategoryName]="restaurant.info.pizza_category_name"
                        [stickyMode]="isSticky"
                        [activeCategoryValue]="currentCategoryValue"
                        [isNewHomePedirDelivery]="true"
                        (scrollToCategory)="scrollToElement($event)"
                    ></category-nav>
                    <div *ngIf="isSticky" class="menu-search-item" (click)="openSearchModal()">
                        <svg class="menu-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                        <span class="menu-search-placeholder">{{ 'Search' | translate }}</span>
                    </div>
                </div>
                <div *ngIf="isSticky" class="menu-sticky-spacer" aria-hidden="true"></div>
                <div *ngIf="!isSticky" class="menu-search-below">
                    <div class="menu-search-item" (click)="openSearchModal()">
                        <svg class="menu-search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
                        <span class="menu-search-placeholder">{{ 'Search' | translate }}</span>
                    </div>
                </div>
            </ng-container>

            <!-- Versão antiga (master): ion-segment sticky nativo do Ionic + ion-item search -->
            <!-- TODO: remove this when new pedir delivery is on 100% of the clients -->
            <ng-container *ngIf="!isNewHomePedirDelivery">
                <category-nav
                    [categories]="categories"
                    [itemsToHide]="itemsToHide"
                    [comboCategoryName]="restaurant.info.combo_category_name"
                    [pizzaCategoryName]="restaurant.info.pizza_category_name"
                    (scrollToCategory)="scrollToElement($event)"
                ></category-nav>
                <ion-item>
                    <ion-label position="floating" translate>
                        <ion-icon name="search-outline"></ion-icon> Search
                    </ion-label>
                    <ion-input #ionicInput enterkeyhint="search" type="search" inputmode="search" (ionInput)="onNewSearchInput($event)"></ion-input>
                </ion-item>
            </ng-container>

            <app-menu-list [menu]="isNewHomePedirDelivery ? restaurant?.menu : (searchResults || restaurant?.menu)" [info]="restaurant.info"></app-menu-list>
        </div>
    </div>

    <ion-footer class="footer-MP" *ngIf="!invalidURL">
        <div class="footer-content">
            <div class="footer-section">
                <p class="developed-by" translate>Developed by</p>
                
                <a [href]="footerLink" target="_blank" class="logo-link">
                    <img class="MP-logo" src="assets/icon/mp-footer-horizontal.png" alt="Multipedidos Logo">
                </a>
                
                <div class="footer-links">
                    <a [href]="footerLink" target="_blank" class="footer-cta">
                        {{ footerLinkText }}
                    </a>
                </div>
            </div>
            
            <div class="footer-divider"></div>
            
            <div class="footer-bottom">
                <p class="company-name">© {{ getCurrentYear() }} Multipedidos Soluções de Software LTDA</p>
            </div>
        </div>
    </ion-footer>
</ion-content>